import React from 'react';
import { Tabs, Tab, Box, Paper } from '@mui/material';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';

/**
 * CustomerDashTabs
 * Container that renders top tabs for Customer dashboards and an Outlet below.
 * Tabs:
 *  - Documents -> /cst/dash/documents
 *  - Insights  -> /cst/dash/insights
 */
export default function CustomerDashTabs() {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { label: 'Document Services', value: 'documents', path: '/cst/dash/documents' },
    { label: 'Insights', value: 'insights', path: '/cst/dash/insights' },
    { label: 'Financial', value: 'financial', path: '/cst/dash/financial' },
  ];

  // Determine active tab based on current pathname
  const active = React.useMemo(() => {
    if (location.pathname.includes('/cst/dash/insights')) return 'insights';
    if (location.pathname.includes('/cst/dash/financial')) return 'financial';
    return 'documents';
  }, [location.pathname]);

  const handleChange = (e, newValue) => {
    const t = tabs.find((t) => t.value === newValue);
    if (t) navigate(t.path);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Paper sx={{ mb: 2, borderRadius: 2 }}>
        <Tabs
          value={active}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Customer dashboards"
          textColor="primary"
          indicatorColor="primary"
        >
          {tabs.map((t) => (
            <Tab key={t.value} value={t.value} label={t.label} />
          ))}
        </Tabs>
      </Paper>
      {/* Nested dashboards render here */}
      <Box sx={{ mt: 1 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
